module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('pkHeader', {
    attrs: {
      "headerTitle": _vm.title,
      "rightContentPropsMain": false
    }
  }), _vm._v(" "), (_vm.datac.length) ? [_c('city', {
    attrs: {
      "datac": _vm.datac,
      "flagvalue": _vm.flag
    },
    on: {
      "update:datac": function($event) {
        _vm.datac = $event
      }
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fd1d80e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/posi.vue
// module id = 407
// module chunks = 1